import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import type { Booth } from '../../interfaces/interfaces';
import { getBooths, updateBooth } from '../../services/services';

interface ImportModalProps {
  booth?: Booth;
  onClose: () => void;
}

const ImportModal = (props: ImportModalProps) => {
  const { booth, onClose } = props;

  const { t } = useTranslation('account');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [allBooths, setAllBooths] = useState<Booth[]>([]);
  const router = useRouter();

  async function fetchData() {
    if (!booth) return;

    setIsLoading(true);

    const booths = await getBooths({
      orgid: booth?.organization?._id as any,
      population: { path: 'event' },
    });

    if (!booth) return;
    setAllBooths(booths.data.filter((b) => b._id !== booth._id));
    setIsLoading(false);
  }

  async function handleImport(importedBooth: any) {
    setIsLoading(true);

    if (!booth) return;
    const boothUpdateData = importedBooth;
    delete boothUpdateData.event;
    delete boothUpdateData.allowExternalSpeakers;
    delete boothUpdateData.maxPresentations;
    delete boothUpdateData.maxMeetings;
    delete boothUpdateData.boothnumber;
    delete boothUpdateData.maxConferences;
    delete boothUpdateData.categoryFilterValues;
    delete boothUpdateData.datetime_created;
    delete boothUpdateData.datetime_hostinvite_sent;
    delete boothUpdateData.id;
    delete boothUpdateData._id;
    delete boothUpdateData.organization;
    delete boothUpdateData.sortIndex;
    delete boothUpdateData.settings;
    await updateBooth({
      ...boothUpdateData,
      ...{
        boothid: booth._id,
      },
    });

    setIsLoading(false);
    onClose();
    router.reload();
  }

  useEffect(() => {
    if (booth) fetchData();
  }, [booth]);

  if (!booth) return null;

  return (
    <div
      onClick={onClose}
      className="overlay inset-0 fixed w-full flex justify-center items-center bg-black bg-opacity-25 hover:cursor-pointer"
      style={{ zIndex: 150 }}>
      <div onClick={(e) => e.stopPropagation()} className="modal bg-white p-4 rounded-lg">
        {isLoading && <CircularProgress />}
        {!isLoading && allBooths.length === 0 && <>{t('account:no-data')}</>}
        {!isLoading && allBooths.length > 0 && (
          <table className="text-left w-full [&>th]:text-left [&>th]:p-4 [&>td]:text-left [&>td]:p-4 ">
            <thead className="bg-slate-400 flex w-full">
              <tr className="flex w-full mb-4">
                <th className="p-4 w-2/5">{t('account:event')}</th>
                <th className="p-4 w-2/5">{t('account:boothname')}</th>
                <th className="p-4 w-1/5" style={{ textAlign: 'right' }} />
              </tr>
            </thead>
            <tbody className="bg-slate-200 flex flex-col items-center justify-between overflow-y-scroll w-full" style={{ height: '50vh' }}>
              {allBooths.map((booth: Booth) => (
                <tr key={booth._id} className="flex w-full">
                  <td className="p-4 w-2/5">{booth?.event?.name}</td>
                  <td className="p-4 w-2/5">{booth?.name}</td>
                  <td className="p-4 w-1/5">
                    <button className="border-none">
                      <FontAwesomeIcon style={{ color: 'var(--vystem-blue)' }} icon={faArrowRight} onClick={() => handleImport(booth)} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ImportModal;
